import React from 'react';
import { Modal } from 'antd';

// import Button from 'components/Button';
import DF from 'DisplayFramework';
import ThirdPartyDetail, { ThirdPartyDetailProps } from './ThirdPartyDetail';
import { ThirdPartyForProposalType } from 'components/ThirdPartyInput';

type ThirdPartyModalProps = Pick<ThirdPartyDetailProps, 'onSelect'> & {
  onCancel: () => void;
  tpId?: number;
  visible: boolean;
  title: string;
  onSuccess?: () => void;
  isProposalCreate?: boolean;
  iscreate?: boolean;
  setThirdPartyForProposal?: (
    ThirdPartyForProposal: ThirdPartyForProposalType
  ) => void;
  hideThirdPartyModal?: () => void;
  hideThirdPartySearchModal?: () => void;
  showAsModal?: boolean;
};

const ThirdPartyModal = (props: ThirdPartyModalProps) => {
  const {
    onCancel,
    tpId,
    visible,
    title,
    iscreate,
    setThirdPartyForProposal,
    hideThirdPartyModal,
    hideThirdPartySearchModal,
    onSelect,
    showAsModal,
  } = props;

  return (
    <DF.Provider pagcode="tpdetail">
      <Modal
        visible={visible}
        onCancel={onCancel}
        width={1600}
        title={title ?? []}
        footer={<> </>}
      >
        <ThirdPartyDetail
          showAsModal={showAsModal}
          tpId={String(tpId)}
          phase="TP"
          isProposalCreate
          setThirdPartyForProposal={setThirdPartyForProposal}
          hideThirdPartySearchModal={hideThirdPartySearchModal}
          hideThirdPartyModal={hideThirdPartyModal}
          iscreate={iscreate}
          onSelect={onSelect}
        />
      </Modal>
    </DF.Provider>
  );
};

export default ThirdPartyModal;
